import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseParamsService } from '@app/core/base-params.service';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { map, retry } from 'rxjs/operators';

export enum MessageType {
  SMS = 'sms',
  EMAIL = 'email',
  PUSH = 'push'
}

export interface Message {
  content: string;
  created_at: string;
  id: string;
  type: MessageType;
}

@Injectable()
export class MessagesService {
  private http = inject(HttpClient);
  private baseParamsService = inject(BaseParamsService);


  public get(encryptedMemberId: string | null, id: string | null): Observable<Message> {
    return this.http.get<Record<string, Message>>(
      `${this.baseUrl()}/members/by_encrypted_id/${encryptedMemberId}/messages/${id}`,
      { params: { type: 'email' } },
    ).pipe(
      retry(3),
      map((json: Record<string, Message>) => json.message),
    );
  }

  private baseUrl(): string {
    return `${environment.webforms_api}/v3/${this.baseParamsService.slug}`;
  }
}
